import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";
import { squareVideo } from "../../shared/square-video";
import { portraitVideo } from "../../shared/portrait-video";
import { getDummyText } from "../../utils";

export default {
    title: "Components/Nimbus USP Tile",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    component: "ux-iws-nb-usp-tile",
    args: {
        openButtonLabel: "More information",
        video: "",
        videoPoster: "https://example.com/placeholder.jpg",
        videoType: "",
        link: "https://example.com",
        linkLabel: "Learn more",
        square: false,
        exampleTextLength: 150,
    },
    argTypes: {
        openButtonLabel: {
            control: "text",
        },
        video: {
            control: "text",
        },
        videoPoster: {
            control: "text",
            description: "an image representing the video",
        },
        videoType: {
            control: "text",
            description: "mime type of the video, e.g. 'video/mp4'",
        },
        link: {
            control: "text",
            description: "the URL of the link",
        },
        linkLabel: {
            control: "text",
            description: "the label of the link",
        },
        square: {
            control: "boolean",
            description: "use square layout",
        },
        exampleTextLength: {
            control: "number",
            description: "length of the lorem ipsum text in characters",
        },
    },
};

const Template = ({
    openButtonLabel,
    video,
    videoPoster,
    videoType,
    link,
    linkLabel,
    square = false,
    exampleTextLength = 150,
}) => {
    return html`
        <ux-iws-nb-usp-tile
            open-button-label="${openButtonLabel}"
            video="${video}"
            video-poster="${videoPoster}"
            video-type="${videoType}"
            link="${link}"
            link-label="${linkLabel}"
            ?square=${square}
        >
            <div slot="initial-title">
                Mit voller Leistung<br />
                <strong>spritzerarm schweißen</strong>
            </div>
            <div slot="layer-title">USP Tile <strong>Title</strong></div>
            <div slot="copy">${getDummyText(exampleTextLength)}</div>
        </ux-iws-nb-usp-tile>
    `;
};

export const Default = Template.bind({});
Default.args = {
    video: portraitVideo,
};

export const Square = Template.bind({});
Square.args = {
    video: squareVideo,
    square: true,
};

export const LongText = Template.bind({});
LongText.args = {
    video: portraitVideo,
    exampleTextLength: 950,
};
